import React from "react";
import { View } from "react-native";

import { CheckBox, OtherText } from "components";

import { styles } from "./styles";

export const CheckBoxQuestion = props => {
  const {
    question,
    selectedOptions,
    selectOption,
    setOptionOtherText,
    isEnglish,
    lang,
    scrollDownBy,
    scrollToEnd,
    addOptionFile,
    removeOptionFile,
    shouldShowAnswer,
  } = props;
  const { options, max_option_selection_count } = question;
  const icon = max_option_selection_count === 1 ? "circle" : "square";

  const containerStyles = [];
  if (options.length > 3) {
    containerStyles.push(styles.container);
  }

  if (!isEnglish && options.length > 3) {
    containerStyles.push(styles.containerRTL);
  }

  const size = styles._checkbox?.fontSize;
  const otherTextStyles = {
    [isEnglish ? "marginLeft" : "marginRight"]: size + 30,
    [isEnglish ? "marginRight" : "marginLeft"]: 30,
  };

  return (
    <View style={containerStyles}>
      {options.map(option => {
        const onCapture = (file, type) => {
          addOptionFile(question, option, file, type);
          setTimeout(() => scrollDownBy(100), 50);
        };
        const removeFile = id => removeOptionFile(question, option, id);
        const selectedOption = selectedOptions[option.virtual_id];
        const shouldRenderIsOther = selectedOption && option.is_other;
        const checkBoxProps = {
          icon,
          size,
          text: option[lang],
          iconRight: !isEnglish,
          checked: !!selectedOption || (shouldShowAnswer && option.is_correct),
          isCorrect: shouldShowAnswer ? option.is_correct : null,
          onPress: () => {
            selectOption(question, option);
            if (option.is_other && !selectedOption) {
              setTimeout(() => scrollDownBy(80), 50);
            }
          },
        };
        const otherTextProps = {
          lang,
          option,
          selectedOption,
          onCapture,
          removeFile,
          scrollToEnd,
          containerStyle: otherTextStyles,
          onChangeText: text => setOptionOtherText(question, option, text),
        };
        return (
          <View key={option.virtual_id} style={styles.checkbox}>
            <CheckBox {...checkBoxProps} />
            {shouldRenderIsOther && <OtherText {...otherTextProps} />}
          </View>
        );
      })}
    </View>
  );
};
